import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Play, Radio, Calendar } from "lucide-react";
import { api } from "@/lib/api";

export const useUltimoEpisodio = () => {
  const [videos, setVideos] = useState([]);
  useEffect(() => {
    const load = () => api.get("/youtube/videos?limit=15").then(({ data }) => setVideos(data.videos.filter((v) => !v.short))).catch(() => {});
    load();
    const t = setInterval(load, 10 * 60 * 1000);
    return () => clearInterval(t);
  }, []);
  return { latest: videos[0] || null, videos };
};

const esNuevo = (iso) => iso && Date.now() - new Date(iso).getTime() < 14 * 24 * 3600 * 1000;

export const UltimoEpisodio = ({ video, tone = "dark" }) => {
  const [playing, setPlaying] = useState(false);
  if (!video) return null;
  const nuevo = esNuevo(video.published);
  const dark = tone === "dark";
  return (
    <motion.div initial={{ opacity: 0, y: 30, scale: 0.97 }} whileInView={{ opacity: 1, y: 0, scale: 1 }} viewport={{ once: true, amount: 0.3 }} transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }} data-testid="ultimo-episodio" className="relative">
      <div className="flex items-center gap-3 mb-4">
        <span className="relative flex h-3 w-3"><span className="absolute inset-0 rounded-full bg-cometa-carmesi animate-ping opacity-75" /><span className="relative h-3 w-3 rounded-full bg-cometa-carmesi" /></span>
        <p className={`text-xs tracking-[0.3em] font-semibold ${dark ? "text-cometa-dorado" : "text-cometa-carmesi"}`} data-testid="ultimo-episodio-badge">{nuevo ? "NUEVO EPISODIO · RECIÉN PUBLICADO" : "ÚLTIMO EPISODIO"}</p>
      </div>
      <div className={`relative aspect-video rounded-3xl overflow-hidden shadow-2xl border ${dark ? "border-cometa-crema/10" : "border-cometa-marino/10"} bg-cometa-tinta group`}>
        {playing ? (
          <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${video.id}?autoplay=1`} title={video.title} allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />
        ) : (
          <button onClick={() => setPlaying(true)} className="w-full h-full relative text-left" aria-label={`Reproducir ${video.title}`} data-testid="ultimo-episodio-play">
            <motion.img src={video.thumbnail.replace("hqdefault", "maxresdefault")} onError={(e) => { e.currentTarget.src = video.thumbnail; }} alt={video.title} className="w-full h-full object-cover" animate={{ scale: [1, 1.05, 1] }} transition={{ duration: 14, repeat: Infinity, ease: "easeInOut" }} />
            <span className="absolute inset-0 bg-gradient-to-t from-cometa-tinta/90 via-cometa-tinta/20 to-transparent" />
            <span className="absolute inset-0 flex items-center justify-center">
              <motion.span whileHover={{ scale: 1.1 }} className="relative flex h-20 w-20 md:h-24 md:w-24 items-center justify-center rounded-full bg-cometa-carmesi text-white shadow-2xl">
                <span className="absolute inset-0 rounded-full bg-cometa-carmesi animate-ping opacity-40" />
                <Play size={34} fill="currentColor" className="relative ml-1" />
              </motion.span>
            </span>
            <span className="absolute left-5 right-5 bottom-5 text-white">
              <span className="block text-xl md:text-2xl lg:text-3xl font-display leading-tight line-clamp-2" data-testid="ultimo-episodio-titulo">{video.title}</span>
              {video.published && <span className="mt-2 inline-flex items-center gap-2 text-sm text-white/80"><Calendar size={14} /> {new Date(video.published).toLocaleDateString("es-MX", { day: "numeric", month: "long", year: "numeric" })}</span>}
            </span>
          </button>
        )}
        <span className="absolute top-4 left-4 inline-flex items-center gap-2 bg-cometa-dorado text-cometa-tinta text-xs font-bold tracking-widest px-3 py-1.5 rounded-full"><Radio size={14} /> {nuevo ? "NUEVO" : "YOUTUBE"}</span>
      </div>
    </motion.div>
  );
};
